// // import React, { useState } from "react";
// // import {
// //     FaSms,
// //     FaMobileAlt,
// //     FaExclamationTriangle,
// //     FaToggleOn,
// //     FaToggleOff,
// //     FaCheckCircle
// // } from "react-icons/fa";

// // const SMSSettings = () => {
// //     const isMobile = window.innerWidth <= 768;
    
// //     const [smsSettings, setSmsSettings] = useState({
// //         enabled: true,
// //         lowStockAlerts: true,
// //         highValueOrders: true,
// //         orderConfirmation: false,
// //         paymentUpdates: true,
// //         criticalAlerts: true,
// //         dailySummary: false,
// //         phoneNumber: "+91 9876543210"
// //     });

// //     const toggleSmsSetting = (setting) => {
// //         setSmsSettings(prev => ({
// //             ...prev,
// //             [setting]: !prev[setting]
// //         }));
// //     };

// //     const updatePhoneNumber = (value) => {
// //         setSmsSettings(prev => ({
// //             ...prev,
// //             phoneNumber: value
// //         }));
// //     };

// //     return (
// //         <div>
// //             {/* Header */}
// //             <div style={{
// //                 display: 'flex',
// //                 alignItems: 'center',
// //                 gap: '15px',
// //                 marginBottom: '20px',
// //                 flexDirection: isMobile ? 'column' : 'row',
// //                 textAlign: isMobile ? 'center' : 'left'
// //             }}>
// //                 <div style={{
// //                     width: isMobile ? '50px' : '60px',
// //                     height: isMobile ? '50px' : '60px',
// //                     borderRadius: '50%',
// //                     backgroundColor: '#e3f2fd',
// //                     display: 'flex',
// //                     alignItems: 'center',
// //                     justifyContent: 'center',
// //                     flexShrink: 0
// //                 }}>
// //                     <FaSms style={{
// //                         fontSize: isMobile ? '24px' : '28px',
// //                         color: '#2196F3'
// //                     }} />
// //                 </div>
// //                 <div style={{ flex: 1 }}>
// //                     <h3 style={{
// //                         margin: 0,
// //                         color: '#333',
// //                         fontSize: isMobile ? '18px' : '24px'
// //                     }}>
// //                         SMS Notification Settings
// //                     </h3>
// //                     <p style={{
// //                         margin: '5px 0 0 0',
// //                         color: '#666',
// //                         fontSize: isMobile ? '13px' : '14px'
// //                     }}>
// //                         Configure how you receive SMS alerts for your business
// //                     </p>
// //                 </div>
// //             </div>

// //             {/* SMS Toggle */}
// //             <div style={{
// //                 display: 'flex',
// //                 justifyContent: 'space-between',
// //                 alignItems: 'center',
// //                 padding: isMobile ? '15px' : '20px',
// //                 backgroundColor: smsSettings.enabled ? '#e8f5e9' : '#f5f5f5',
// //                 borderRadius: '10px',
// //                 marginBottom: '20px'
// //             }}>
// //                 <div>
// //                     <h4 style={{
// //                         margin: '0 0 5px 0',
// //                         color: '#333',
// //                         fontSize: isMobile ? '16px' : '18px'
// //                     }}>
// //                         Enable SMS Notifications
// //                     </h4>
// //                     <p style={{
// //                         margin: 0,
// //                         color: '#666',
// //                         fontSize: isMobile ? '13px' : '14px'
// //                     }}>
// //                         {smsSettings.enabled
// //                             ? 'SMS notifications are currently active'
// //                             : 'SMS notifications are disabled'
// //                         }
// //                     </p>
// //                 </div>
// //                 <button
// //                     onClick={() => toggleSmsSetting('enabled')}
// //                     style={{
// //                         background: 'none',
// //                         border: 'none',
// //                         fontSize: isMobile ? '32px' : '40px',
// //                         color: smsSettings.enabled ? '#4CAF50' : '#ccc',
// //                         cursor: 'pointer',
// //                         display: 'flex',
// //                         alignItems: 'center'
// //                     }}
// //                 >
// //                     {smsSettings.enabled ? <FaToggleOn /> : <FaToggleOff />}
// //                 </button>
// //             </div>

// //             {/* Phone Number Input */}
// //             {smsSettings.enabled && (
// //                 <div style={{
// //                     padding: isMobile ? '15px' : '20px',
// //                     backgroundColor: '#f0f8ff',
// //                     borderRadius: '10px',
// //                     marginBottom: '20px'
// //                 }}>
// //                     <h4 style={{
// //                         margin: '0 0 15px 0',
// //                         color: '#333',
// //                         fontSize: isMobile ? '16px' : '18px'
// //                     }}>
// //                         <FaMobileAlt style={{ marginRight: '10px' }} />
// //                         Phone Number for SMS Alerts
// //                     </h4>
// //                     <div style={{
// //                         display: 'flex',
// //                         gap: '10px',
// //                         alignItems: 'center',
// //                         flexDirection: isMobile ? 'column' : 'row'
// //                     }}>
// //                         <input
// //                             type="tel"
// //                             value={smsSettings.phoneNumber}
// //                             onChange={(e) => updatePhoneNumber(e.target.value)}
// //                             style={{
// //                                 flex: 1,
// //                                 padding: '12px',
// //                                 border: '1px solid #ddd',
// //                                 borderRadius: '6px',
// //                                 fontSize: isMobile ? '14px' : '16px',
// //                                 width: '100%',
// //                                 boxSizing: 'border-box'
// //                             }}
// //                             placeholder="Enter phone number with country code"
// //                         />
// //                         <button
// //                             onClick={() => alert('Phone number updated!')}
// //                             style={{
// //                                 padding: '12px 24px',
// //                                 backgroundColor: '#2196F3',
// //                                 color: 'white',
// //                                 border: 'none',
// //                                 borderRadius: '6px',
// //                                 cursor: 'pointer',
// //                                 fontSize: isMobile ? '13px' : '14px',
// //                                 fontWeight: '600',
// //                                 width: isMobile ? '100%' : 'auto',
// //                                 flexShrink: 0
// //                             }}
// //                         >
// //                             Update
// //                         </button>
// //                     </div>
// //                     <p style={{
// //                         margin: '10px 0 0 0',
// //                         color: '#666',
// //                         fontSize: isMobile ? '12px' : '13px'
// //                     }}>
// //                         <FaExclamationTriangle style={{ marginRight: '5px' }} />
// //                         Standard SMS rates may apply. For international numbers, check with your carrier.
// //                     </p>
// //                 </div>
// //             )}

// //             {/* SMS Alert Types */}
// //             {smsSettings.enabled && (
// //                 <div>
// //                     <h4 style={{
// //                         margin: '0 0 20px 0',
// //                         color: '#333',
// //                         fontSize: isMobile ? '16px' : '18px'
// //                     }}>
// //                         Select SMS Alert Types
// //                     </h4>
// //                     <div style={{
// //                         display: 'grid',
// //                         gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))',
// //                         gap: '15px'
// //                     }}>
// //                         {[
// //                             { key: 'lowStockAlerts', label: 'Low Stock Alerts', description: 'Get notified when inventory is running low' },
// //                             { key: 'highValueOrders', label: 'High-Value Orders', description: 'Alerts for orders above ₹5,000' },
// //                             { key: 'orderConfirmation', label: 'Order Confirmations', description: 'SMS for every new order' },
// //                             { key: 'paymentUpdates', label: 'Payment Updates', description: 'Payment received/failed notifications' },
// //                             { key: 'criticalAlerts', label: 'Critical Alerts', description: 'Emergency system notifications' },
// //                             { key: 'dailySummary', label: 'Daily Summary', description: 'End-of-day business summary' }
// //                         ].map(item => (
// //                             <div key={item.key} style={{
// //                                 display: 'flex',
// //                                 justifyContent: 'space-between',
// //                                 alignItems: 'center',
// //                                 padding: '15px',
// //                                 backgroundColor: '#f9f9f9',
// //                                 borderRadius: '8px',
// //                                 border: '1px solid #e0e0e0'
// //                             }}>
// //                                 <div style={{ flex: 1, marginRight: '15px' }}>
// //                                     <div style={{
// //                                         fontSize: isMobile ? '14px' : '16px',
// //                                         fontWeight: '600',
// //                                         color: smsSettings[item.key] ? '#333' : '#999'
// //                                     }}>
// //                                         {item.label}
// //                                     </div>
// //                                     <div style={{
// //                                         fontSize: isMobile ? '12px' : '13px',
// //                                         color: smsSettings[item.key] ? '#666' : '#bbb',
// //                                         marginTop: '5px'
// //                                     }}>
// //                                         {item.description}
// //                                     </div>
// //                                 </div>
// //                                 <button
// //                                     onClick={() => toggleSmsSetting(item.key)}
// //                                     style={{
// //                                         background: 'none',
// //                                         border: 'none',
// //                                         fontSize: isMobile ? '24px' : '28px',
// //                                         color: smsSettings[item.key] ? '#4CAF50' : '#ccc',
// //                                         cursor: 'pointer',
// //                                         display: 'flex',
// //                                         alignItems: 'center',
// //                                         flexShrink: 0
// //                                     }}
// //                                 >
// //                                     {smsSettings[item.key] ? <FaToggleOn /> : <FaToggleOff />}
// //                                 </button>
// //                             </div>
// //                         ))}
// //                     </div>
// //                 </div>
// //             )}

// //             {/* Save Button */}
// //             <div style={{ marginTop: '30px', textAlign: 'center' }}>
// //                 <button
// //                     onClick={() => alert('SMS settings saved successfully!')}
// //                     style={{
// //                         backgroundColor: '#4CAF50',
// //                         color: 'white',
// //                         border: 'none',
// //                         padding: isMobile ? '12px 30px' : '15px 40px',
// //                         borderRadius: '8px',
// //                         cursor: 'pointer',
// //                         fontSize: isMobile ? '14px' : '16px',
// //                         fontWeight: '600',
// //                         display: 'inline-flex',
// //                         alignItems: 'center',
// //                         gap: '10px',
// //                         boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)',
// //                         transition: 'all 0.3s ease'
// //                     }}
// //                     onMouseEnter={(e) => {
// //                         e.currentTarget.style.backgroundColor = '#388E3C';
// //                         e.currentTarget.style.transform = 'translateY(-2px)';
// //                     }}
// //                     onMouseLeave={(e) => {
// //                         e.currentTarget.style.backgroundColor = '#4CAF50';
// //                         e.currentTarget.style.transform = 'translateY(0)';
// //                     }}
// //                 >
// //                     <FaCheckCircle /> Save SMS Settings
// //                 </button>
// //             </div>
// //         </div>
// //     );
// // };

// // export default SMSSettings;


// import React, { useState } from "react";
// import {
//     FaSms,
//     FaMobileAlt,
//     FaExclamationTriangle,
//     FaCheckCircle,
//     FaToggleOn,
//     FaToggleOff
// } from "react-icons/fa";

// function SMSSettings({ isMobile }) {
//     const [smsSettings, setSmsSettings] = useState({
//         enabled: true,
//         lowStockAlerts: true,
//         highValueOrders: true,
//         orderConfirmation: false,
//         paymentUpdates: true,
//         criticalAlerts: true,
//         dailySummary: false,
//         phoneNumber: "+91 9876543210"
//     });

//     // Toggle SMS settings
//     const toggleSmsSetting = (setting) => {
//         setSmsSettings(prev => ({
//             ...prev,
//             [setting]: !prev[setting]
//         }));
//     };

//     // Update SMS phone number
//     const updatePhoneNumber = (value) => {
//         setSmsSettings(prev => ({
//             ...prev,
//             phoneNumber: value
//         }));
//     };

//     return (
//         <div style={{
//             backgroundColor: 'white',
//             borderRadius: '10px',
//             padding: isMobile ? '15px' : '30px',
//             boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
//             marginBottom: '20px'
//         }}>
            
//             {/* SMS Toggle */}
//             <div style={{
//                 display: 'flex',
//                 justifyContent: 'space-between',
//                 alignItems: 'center',
//                 padding: isMobile ? '15px' : '20px',
//                 backgroundColor: smsSettings.enabled ? '#e8f5e9' : '#f5f5f5',
//                 borderRadius: '10px',
//                 marginBottom: '20px'
//             }}>
//                 <div>
//                     <h4 style={{
//                         margin: '0 0 5px 0',
//                         color: '#333',
//                         fontSize: isMobile ? '16px' : '18px'
//                     }}>
//                         Enable SMS Notifications
//                     </h4>
//                     <p style={{
//                         margin: 0,
//                         color: '#666',
//                         fontSize: isMobile ? '13px' : '14px'
//                     }}>
//                         {smsSettings.enabled
//                             ? 'SMS notifications are currently active'
//                             : 'SMS notifications are disabled'
//                         }
//                     </p>
//                 </div>
//                 <button
//                     onClick={() => toggleSmsSetting('enabled')}
//                     style={{
//                         background: 'none',
//                         border: 'none',
//                         fontSize: isMobile ? '32px' : '40px',
//                         color: smsSettings.enabled ? '#4CAF50' : '#ccc',
//                         cursor: 'pointer',
//                         display: 'flex',
//                         alignItems: 'center'
//                     }}
//                 >
//                     {smsSettings.enabled ? <FaToggleOn /> : <FaToggleOff />}
//                 </button>
//             </div>

//             {/* Phone Number Input */}
//             {smsSettings.enabled && (
//                 <div style={{
//                     padding: isMobile ? '15px' : '20px',
//                     backgroundColor: '#f0f8ff',
//                     borderRadius: '10px',
//                     marginBottom: '20px'
//                 }}>
//                     <h4 style={{
//                         margin: '0 0 15px 0',
//                         color: '#333',
//                         fontSize: isMobile ? '16px' : '18px'
//                     }}>
//                         <FaMobileAlt style={{ marginRight: '10px' }} />
//                         Phone Number for SMS Alerts
//                     </h4>
//                     <div style={{
//                         display: 'flex',
//                         gap: '10px',
//                         alignItems: 'center',
//                         flexDirection: isMobile ? 'column' : 'row'
//                     }}>
//                         <input
//                             type="tel"
//                             value={smsSettings.phoneNumber}
//                             onChange={(e) => updatePhoneNumber(e.target.value)}
//                             style={{
//                                 flex: 1,
//                                 padding: '12px',
//                                 border: '1px solid #ddd',
//                                 borderRadius: '6px',
//                                 fontSize: isMobile ? '14px' : '16px',
//                                 width: '100%',
//                                 boxSizing: 'border-box'
//                             }}
//                             placeholder="Enter phone number with country code"
//                         />
//                         <button
//                             onClick={() => alert('Phone number updated!')}
//                             style={{
//                                 padding: '12px 24px',
//                                 backgroundColor: '#2196F3',
//                                 color: 'white',
//                                 border: 'none',
//                                 borderRadius: '6px',
//                                 cursor: 'pointer',
//                                 fontSize: isMobile ? '13px' : '14px',
//                                 fontWeight: '600',
//                                 width: isMobile ? '100%' : 'auto',
//                                 flexShrink: 0
//                             }}
//                         >
//                             Update
//                         </button>
//                     </div>
//                     <p style={{
//                         margin: '10px 0 0 0',
//                         color: '#666',
//                         fontSize: isMobile ? '12px' : '13px'
//                     }}>
//                         <FaExclamationTriangle style={{ marginRight: '5px' }} />
//                         Standard SMS rates may apply. For international numbers, check with your carrier.
//                     </p>
//                 </div>
//             )}

//             {/* SMS Alert Types */}
//             {smsSettings.enabled && (
//                 <div>
//                     <h4 style={{
//                         margin: '0 0 20px 0',
//                         color: '#333',
//                         fontSize: isMobile ? '16px' : '18px'
//                     }}>
//                         Select SMS Alert Types
//                     </h4>
//                     <div style={{
//                         display: 'grid',
//                         gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))',
//                         gap: '15px'
//                     }}>
//                         {[
//                             { key: 'lowStockAlerts', label: 'Low Stock Alerts', description: 'Get notified when inventory is running low' },
//                             { key: 'highValueOrders', label: 'High-Value Orders', description: 'Alerts for orders above ₹5,000' },
//                             { key: 'orderConfirmation', label: 'Order Confirmations', description: 'SMS for every new order' },
//                             { key: 'paymentUpdates', label: 'Payment Updates', description: 'Payment received/failed notifications' },
//                             { key: 'criticalAlerts', label: 'Critical Alerts', description: 'Emergency system notifications' },
//                             { key: 'dailySummary', label: 'Daily Summary', description: 'End-of-day business summary' }
//                         ].map(item => (
//                             <div key={item.key} style={{
//                                 display: 'flex',
//                                 justifyContent: 'space-between',
//                                 alignItems: 'center',
//                                 padding: '15px',
//                                 backgroundColor: '#f9f9f9',
//                                 borderRadius: '8px',
//                                 border: '1px solid #e0e0e0'
//                             }}>
//                                 <div style={{ flex: 1, marginRight: '15px' }}>
//                                     <div style={{
//                                         fontSize: isMobile ? '14px' : '16px',
//                                         fontWeight: '600',
//                                         color: smsSettings[item.key] ? '#333' : '#999'
//                                     }}>
//                                         {item.label}
//                                     </div>
//                                     <div style={{
//                                         fontSize: isMobile ? '12px' : '13px',
//                                         color: smsSettings[item.key] ? '#666' : '#bbb',
//                                         marginTop: '5px'
//                                     }}>
//                                         {item.description}
//                                     </div>
//                                 </div>
//                                 <button
//                                     onClick={() => toggleSmsSetting(item.key)}
//                                     style={{
//                                         background: 'none',
//                                         border: 'none',
//                                         fontSize: isMobile ? '24px' : '28px',
//                                         color: smsSettings[item.key] ? '#4CAF50' : '#ccc',
//                                         cursor: 'pointer',
//                                         display: 'flex',
//                                         alignItems: 'center',
//                                         flexShrink: 0
//                                     }}
//                                 >
//                                     {smsSettings[item.key] ? <FaToggleOn /> : <FaToggleOff />}
//                                 </button>
//                             </div>
//                         ))}
//                     </div>
//                 </div>
//             )}

//             {/* Save Button */}
//             <div style={{ marginTop: '30px', textAlign: 'center' }}>
//                 <button
//                     onClick={() => alert('SMS settings saved successfully!')}
//                     style={{
//                         backgroundColor: '#4CAF50',
//                         color: 'white',
//                         border: 'none',
//                         padding: isMobile ? '12px 30px' : '15px 40px',
//                         borderRadius: '8px',
//                         cursor: 'pointer',
//                         fontSize: isMobile ? '14px' : '16px',
//                         fontWeight: '600',
//                         display: 'inline-flex',
//                         alignItems: 'center',
//                         gap: '10px',
//                         boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)',
//                         transition: 'all 0.3s ease'
//                     }}
//                     onMouseEnter={(e) => {
//                         e.currentTarget.style.backgroundColor = '#388E3C';
//                         e.currentTarget.style.transform = 'translateY(-2px)';
//                     }}
//                     onMouseLeave={(e) => {
//                         e.currentTarget.style.backgroundColor = '#4CAF50';
//                         e.currentTarget.style.transform = 'translateY(0)';
//                     }}
//                 >
//                     <FaCheckCircle /> Save SMS Settings
//                 </button>
//             </div>
//         </div>
//     );
// }

// export default SMSSettings;




import React, { useState } from "react";
import {
    FaSms,
    FaMobileAlt,
    FaExclamationTriangle,
    FaCheckCircle,
    FaToggleOn,
    FaToggleOff
} from "react-icons/fa";

function SmsSettings({ isMobile }) {
    const [smsSettings, setSmsSettings] = useState({
        enabled: true,
        lowStockAlerts: true,
        highValueOrders: true,
        orderConfirmation: false,
        paymentUpdates: true,
        criticalAlerts: true,
        dailySummary: false,
        phoneNumber: "+91 9876543210"
    });

    // Toggle SMS settings
    const toggleSmsSetting = (setting) => {
        setSmsSettings(prev => ({
            ...prev,
            [setting]: !prev[setting]
        }));
    };

    // Update SMS phone number
    const updatePhoneNumber = (value) => {
        setSmsSettings(prev => ({
            ...prev,
            phoneNumber: value
        }));
    };

    return (
        <div style={{
            backgroundColor: 'white',
            borderRadius: '10px',
            padding: isMobile ? '15px' : '30px',
            boxShadow: '0 2px 10px rgba(0,0,0,0.1)',
            marginBottom: '20px'
        }}>
            
            {/* SMS Toggle */}
            <div style={{
                display: 'flex',
                justifyContent: 'space-between',
                alignItems: 'center',
                padding: isMobile ? '15px' : '20px',
                backgroundColor: smsSettings.enabled ? '#e8f5e9' : '#f5f5f5',
                borderRadius: '10px',
                marginBottom: '20px'
            }}>
                <div>
                    <h4 style={{
                        margin: '0 0 5px 0',
                        color: '#333',
                        fontSize: isMobile ? '16px' : '18px'
                    }}>
                        Enable SMS Notifications
                    </h4>
                    <p style={{
                        margin: 0,
                        color: '#666',
                        fontSize: isMobile ? '13px' : '14px'
                    }}>
                        {smsSettings.enabled
                            ? 'SMS notifications are currently active'
                            : 'SMS notifications are disabled'
                        }
                    </p>
                </div>
                <button
                    onClick={() => toggleSmsSetting('enabled')}
                    style={{
                        background: 'none',
                        border: 'none',
                        fontSize: isMobile ? '32px' : '40px',
                        color: smsSettings.enabled ? '#4CAF50' : '#ccc',
                        cursor: 'pointer',
                        display: 'flex',
                        alignItems: 'center'
                    }}
                >
                    {smsSettings.enabled ? <FaToggleOn /> : <FaToggleOff />}
                </button>
            </div>

            {/* Phone Number Input */}
            {smsSettings.enabled && (
                <div style={{
                    padding: isMobile ? '15px' : '20px',
                    backgroundColor: '#f0f8ff',
                    borderRadius: '10px',
                    marginBottom: '20px'
                }}>
                    <h4 style={{
                        margin: '0 0 15px 0',
                        color: '#333',
                        fontSize: isMobile ? '16px' : '18px'
                    }}>
                        <FaMobileAlt style={{ marginRight: '10px' }} />
                        Phone Number for SMS Alerts
                    </h4>
                    <div style={{
                        display: 'flex',
                        gap: '10px',
                        alignItems: 'center',
                        flexDirection: isMobile ? 'column' : 'row'
                    }}>
                        <input
                            type="tel"
                            value={smsSettings.phoneNumber}
                            onChange={(e) => updatePhoneNumber(e.target.value)}
                            style={{
                                flex: 1,
                                padding: '12px',
                                border: '1px solid #ddd',
                                borderRadius: '6px',
                                fontSize: isMobile ? '14px' : '16px',
                                width: '100%',
                                boxSizing: 'border-box'
                            }}
                            placeholder="Enter phone number with country code"
                        />
                        <button
                            onClick={() => alert('Phone number updated!')}
                            style={{
                                padding: '12px 24px',
                                backgroundColor: '#2196F3',
                                color: 'white',
                                border: 'none',
                                borderRadius: '6px',
                                cursor: 'pointer',
                                fontSize: isMobile ? '13px' : '14px',
                                fontWeight: '600',
                                width: isMobile ? '100%' : 'auto',
                                flexShrink: 0
                            }}
                        >
                            Update
                        </button>
                    </div>
                    <p style={{
                        margin: '10px 0 0 0',
                        color: '#666',
                        fontSize: isMobile ? '12px' : '13px'
                    }}>
                        <FaExclamationTriangle style={{ marginRight: '5px' }} />
                        Standard SMS rates may apply. For international numbers, check with your carrier.
                    </p>
                </div>
            )}

            {/* SMS Alert Types */}
            {smsSettings.enabled && (
                <div>
                    <h4 style={{
                        margin: '0 0 20px 0',
                        color: '#333',
                        fontSize: isMobile ? '16px' : '18px'
                    }}>
                        Select SMS Alert Types
                    </h4>
                    <div style={{
                        display: 'grid',
                        gridTemplateColumns: isMobile ? '1fr' : 'repeat(auto-fit, minmax(300px, 1fr))',
                        gap: '15px'
                    }}>
                        {[
                            { key: 'lowStockAlerts', label: 'Low Stock Alerts', description: 'Get notified when inventory is running low' },
                            { key: 'highValueOrders', label: 'High-Value Orders', description: 'Alerts for orders above ₹5,000' },
                            { key: 'orderConfirmation', label: 'Order Confirmations', description: 'SMS for every new order' },
                            { key: 'paymentUpdates', label: 'Payment Updates', description: 'Payment received/failed notifications' },
                            { key: 'criticalAlerts', label: 'Critical Alerts', description: 'Emergency system notifications' },
                            { key: 'dailySummary', label: 'Daily Summary', description: 'End-of-day business summary' }
                        ].map(item => (
                            <div key={item.key} style={{
                                display: 'flex',
                                justifyContent: 'space-between',
                                alignItems: 'center',
                                padding: '15px',
                                backgroundColor: '#f9f9f9',
                                borderRadius: '8px',
                                border: '1px solid #e0e0e0'
                            }}>
                                <div style={{ flex: 1, marginRight: '15px' }}>
                                    <div style={{
                                        fontSize: isMobile ? '14px' : '16px',
                                        fontWeight: '600',
                                        color: smsSettings[item.key] ? '#333' : '#999'
                                    }}>
                                        {item.label}
                                    </div>
                                    <div style={{
                                        fontSize: isMobile ? '12px' : '13px',
                                        color: smsSettings[item.key] ? '#666' : '#bbb',
                                        marginTop: '5px'
                                    }}>
                                        {item.description}
                                    </div>
                                </div>
                                <button
                                    onClick={() => toggleSmsSetting(item.key)}
                                    style={{
                                        background: 'none',
                                        border: 'none',
                                        fontSize: isMobile ? '24px' : '28px',
                                        color: smsSettings[item.key] ? '#4CAF50' : '#ccc',
                                        cursor: 'pointer',
                                        display: 'flex',
                                        alignItems: 'center',
                                        flexShrink: 0
                                    }}
                                >
                                    {smsSettings[item.key] ? <FaToggleOn /> : <FaToggleOff />}
                                </button>
                            </div>
                        ))}
                    </div>
                </div>
            )}

            {/* Save Button */}
            <div style={{ marginTop: '30px', textAlign: 'center' }}>
                <button
                    onClick={() => alert('SMS settings saved successfully!')}
                    style={{
                        backgroundColor: '#4CAF50',
                        color: 'white',
                        border: 'none',
                        padding: isMobile ? '12px 30px' : '15px 40px',
                        borderRadius: '8px',
                        cursor: 'pointer',
                        fontSize: isMobile ? '14px' : '16px',
                        fontWeight: '600',
                        display: 'inline-flex',
                        alignItems: 'center',
                        gap: '10px',
                        boxShadow: '0 4px 15px rgba(76, 175, 80, 0.3)',
                        transition: 'all 0.3s ease'
                    }}
                    onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor = '#388E3C';
                        e.currentTarget.style.transform = 'translateY(-2px)';
                    }}
                    onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = '#4CAF50';
                        e.currentTarget.style.transform = 'translateY(0)';
                    }}
                >
                    <FaCheckCircle /> Save SMS Settings
                </button>
            </div>
        </div>
    );
}

export default SmsSettings;